import { getPluralizedWord } from "@/utils";

import { PLURALIZATION_WORDS, WEEKS_OPTIONS } from "@/constants/repeats";

export const getRepeatText = (repeatRules) => {
  if (!repeatRules) return "";

  const {
    end_date,
    repeat_count,
    n_count,
    m_count,
    only_workdays,
    weeks_days,
    monthly_frequency_option,
    monthly_frequency_val_1,
    monthly_frequency_val_2,
    monthly_frequency_val_3,
    monthly_frequency_val_4,
    monthly_frequency_val_5,
    frequency_by_year_val_1,
    frequency_by_year_val_2,
    frequency_by_year_val_3,
  } = repeatRules;

  // Функции для форматирования различных типов повторения
  const formatDailyRepeat = () => {
    if (!n_count) return "";
    return ` каждый ${n_count > 1 ? `${n_count}-й` : ""} день`;
  };

  const formatWeeklyRepeat = () => {
    if (!m_count) return "";

    const weekDaysText = weeks_days?.length
      ? `в ${weeks_days
          .map(
            (day) => WEEKS_OPTIONS.find((option) => option.value === day)?.label
          )
          .join(", ")}`
      : "";

    const weekIntervalText = `каждую ${
      m_count > 1 ? `${m_count}-ю` : ""
    } неделю`;

    return ` ${weekDaysText} ${weekIntervalText}`;
  };

  const formatMonthlyRepeat = () => {
    if (!monthly_frequency_option) return "";

    if (monthly_frequency_option === "day_of_month") {
      return ` каждый ${
        monthly_frequency_val_2 > 1 ? `${monthly_frequency_val_2}-й` : ""
      } месяц ${monthly_frequency_val_1} числа`;
    }

    if (monthly_frequency_option === "day_of_week_of_month") {
      const weekDay = WEEKS_OPTIONS.find(
        ({ value }) => value === monthly_frequency_val_3
      )?.label;

      return ` в ${weekDay} каждой ${monthly_frequency_val_4}-й недели каждый ${
        monthly_frequency_val_5 > 1 ? `${monthly_frequency_val_5}-й` : ""
      } месяц `;
    }

    return "";
  };

  const formatYearlyRepeat = () => {
    if (!frequency_by_year_val_3) return "";

    const yearIntervalPrefix = getPluralizedWord(frequency_by_year_val_3, [
      "каждый",
      "каждые",
      "каждые",
    ]);

    const yearIntervalNumber =
      frequency_by_year_val_3 > 1 ? frequency_by_year_val_3 : "";
    const yearWord = getPluralizedWord(
      frequency_by_year_val_3,
      PLURALIZATION_WORDS.YEARS
    );
    const dayText = frequency_by_year_val_1
      ? ` ${frequency_by_year_val_1} числа`
      : "";
    const monthText = frequency_by_year_val_2
      ? ` каждого ${frequency_by_year_val_2}-ого месяца`
      : "";

    return ` ${yearIntervalPrefix} ${yearIntervalNumber} ${yearWord}${dayText}${monthText}`;
  };

  const formatWorkdaysOnly = () => {
    return only_workdays ? " в рабочие дни" : "";
  };

  const formatEndConditions = () => {
    const endDateText = end_date
      ? ` до ${end_date.format("DD MMMM YYYY")}`
      : "";
    const repeatCountText = repeat_count
      ? ` и завершить после ${repeat_count} ${getPluralizedWord(
          repeat_count,
          PLURALIZATION_WORDS.REPEATS
        )}`
      : "";

    return endDateText + repeatCountText;
  };

  const parts = [
    formatDailyRepeat(),
    formatWeeklyRepeat(),
    formatMonthlyRepeat(),
    formatYearlyRepeat(),
    formatWorkdaysOnly(),
    formatEndConditions(),
  ].filter(Boolean);

  return "Повторять" + parts.join("");
};
